import { fetchWithAuth } from "digimaker-ui/util";
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";

export const CreateIndependentUser = (props: {
  site_id: number;
  user: any;
  onSuccess: () => void;
  onCancel: () => void;
}) => {
  const { user } = props;
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");

  useEffect(() => {
    if (user) {
      setUsername(user.admin_username);
      setName(user.user_name);
      setPassword("");
    }
  }, [user]);

  const createUser = async () => {
    const data = { username, password, name };
    if (user) {
      data["id"] = user.id;
    }
    const result = await fetchWithAuth(
      process.env.REACT_APP_BRIDGE_API_URL +
        "/clubadmin/users/create_update_independent_user?site_id=" +
        props.site_id,
      {
        method: "POST",
        body: JSON.stringify(data),
      }
    );
    if (result.error === false) {
      if (user) {
        window.alert("Bruker oppdatert");
      } else {
        window.alert("Bruker opprettet");
      }
      props.onSuccess();
      props.onCancel();
    } else {
      window.alert("Feil ved opprettelse av bruker: " + result.data);
    }
  };
  return (
    <div>
      <Modal show centered onHide={props.onCancel}>
        <Modal.Title>
          {props.user ? "Rediger bruker " + user.user_name : "Legg til bruker"}
        </Modal.Title>
        <Modal.Body>
          <div>
            <div>
              <label>Brukernavn:</label>
              <input
                className="form-control"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Brukernavn"
              />
            </div>
            <div style={{ marginTop: 10 }}>
              <label>Navn:</label>
              <input
                className="form-control"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Navn"
              />
            </div>
            <div style={{ marginTop: 10 }}>
              <label>Passord:</label>
              <input
                className="form-control"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Passord"
              />
              <div
                style={{
                  fontSize: 14,
                  color: "#888",
                  padding: 5,
                  marginTop: 4,
                }}
              >
                Ikke fyll ut dersom du ikke ønsker å endre passord.
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.onCancel}>
            Lukk
          </Button>
          <Button variant="primary" onClick={createUser}>
            {props.user ? "Lagre" : "Legg til"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
